import { formatIsoLocalDateTime } from '@townsquare/date-utils/format';
import { getUtcEndOfGoalMonth, parseGoalUpdatesFeedStartDate } from '@townsquare/date-utils/update';
import { RelayResourceConfig, createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import GoalUpdatesListAggQuery, {
	type GoalUpdatesListAggQuery as GoalUpdatesListAggQueryType,
} from '../agg/__generated__/GoalUpdatesListAggQuery.graphql';
import { getUpdateStateFilterFromQueryParams } from '../components/UpdateStateFilter';

export const goalUpdatesAggResource = createRelayResource<GoalUpdatesListAggQueryType>({
	getQuery: (routerContext, resourceContext): RelayResourceConfig<GoalUpdatesListAggQueryType> => {
		const { collabContext } = resourceContext as ResourceContext;
		const utcStartDate = parseGoalUpdatesFeedStartDate(routerContext.query.start);
		const utcEndDate = getUtcEndOfGoalMonth(utcStartDate);

		return {
			query: GoalUpdatesListAggQuery,
			variables: {
				containerId: collabContext?.contextId || '',
				startDate: formatIsoLocalDateTime(utcStartDate),
				endDate: formatIsoLocalDateTime(utcEndDate),
				stateFilter: getUpdateStateFilterFromQueryParams(routerContext.query.filter),
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
